
module.exports = require('./dist/post-robot');
module.exports.default = module.exports;



//////////////////
// WEBPACK FOOTER
// ./node_modules/post-robot/index.js
// module id = 289
// module chunks = 0